import { createElement, FunctionComponent } from 'react';

import { RowButtonProps } from './common/RowButtonProps';
import { RowMenuButton } from './MenuButton';
import { ToggleVisibilityButton } from './ToggleVisibilityButton';

export const EndRowButtons: FunctionComponent<RowButtonProps> = ({ row }) =>
  [ToggleVisibilityButton, RowMenuButton].map((button, i) => createElement(button, { row, key: i }));
